import { render, staticRenderFns } from "./InvitationMobile.vue?vue&type=template&id=63289aa2"
import script from "./InvitationMobile.vue?vue&type=script&lang=js"
export * from "./InvitationMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports